<template>
  <p
    v-if="image.caption"
    :class="css"
  >
    {{ image.caption }}
  </p>
</template>

<script>
// Data models
import Image from '@/models/Image';

export default {
  name: 'ImageCaption',
  props: {
    id: {
      required: true,
      type: Number,
    },
    css: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    image() {
      return Image.query().find(this.id);
    },
  },
};
</script>
